module.exports = __webpack_public_path__ + "img/vender.860337d0.png";